import React, { useState } from "react";
import styles from "./Navigation.module.scss";

const Navigation = () => {
  const [collapse, setCollapse] = useState(true);
  const hamburgerClass = collapse ? styles.hamburger : styles.cross;
  const collapseClass = collapse ? styles.collapse : styles.expand;

  return (
    <div className={styles.Navigation}>
      <div className={styles.mobile}>
        <div className={hamburgerClass} onClick={() => setCollapse(!collapse)}>
          <div></div>
          <div></div>
        </div>

        <div className={collapseClass}>
          <div className={styles.container}>
            <a href="#projects" onClick={() => setCollapse(!collapse)}>
              <li>Projects</li>
            </a>
            <a href="#skills" onClick={() => setCollapse(!collapse)}>
              <li>Skills</li>
            </a>
            <a href="#contact" onClick={() => setCollapse(!collapse)}>
              <li>Contact</li>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.desktop}>
        <a href="#contact">
          <li>contact</li>
        </a>
        <div>|</div>
        <a href="#projects">
          <li>projects</li>
        </a>
        <div>|</div>
        <a href="#experience">
          <li>experience</li>
        </a>
        <div>|</div>
        <a href="#about">
          <li>about</li>
        </a>
      </div>
    </div>
  );
};
export default Navigation;
